import {
  Concentre,
  DetailedConcentre,
  DjangoConcentre,
  DjangoDetailedConcentre,
  DjangoJudicialActions,
  DjangoPEFIN,
  DjangoProtests,
  DjangoREFIN,
  DjangoScoring,
  JudicialActions,
  PEFIN,
  Protests,
  REFIN,
  Scoring
} from './interfaces';

export function parseDjangoConcentre(data?: DjangoConcentre) {
  if (data) {
    const detailedConcentre = {
      protests: parseDjangoProtests(data.protests),
      judicialActions: parseDjangoJudicialActions(data.judicial_actions),
      REFIN: parseDjangoREFIN(data.REFIN),
      PEFIN: parseDjangoPEFIN(data.PEFIN),
      scoring: parseDjangoScoring(data.scoring),
    };
    return detailedConcentre;
  } else {
    return undefined;
  }
}

export function parseConcentre(data?: Concentre) {
  if (data) {
    const detailedConcentre = {
      protests: parseProtests(data.protests),
      judicialActions: parseJudicialActions(data.judicialActions),
      REFIN: parseREFIN(data.REFIN),
      PEFIN: parsePEFIN(data.PEFIN),
      scoring: parseScoring(data.scoring),
    };
    return detailedConcentre;
  } else {
    return undefined;
  }
}

function parseDjangoProtests(data?: DjangoProtests) {
  if (data) {
    const protests = {
      initialDate: data.initial_date,
      finalDate: data.final_date,
      totalAmount: data.total_amount,
      value: data.value,
      cityOfOrigin: data.city_of_origin,
      detail: {
        dateAnnotacion: data.detail?.date_annotacion,
        notaryNumber: data.detail?.notary_number,
        codeOfNature: data.detail?.code_of_nature,
        noteValue: data.detail?.note_value,
        squareCode: data.detail?.square_code,
        federativeUnit: data.detail?.federative_unit,
        localityOfRegistry: data.detail?.locality_of_registry,
        subJudiceType: data.detail?.sub_judice_type,
        receivingDate: data.detail?.receiving_date,
        branchNumber: data.detail?.branch_number,
        verifyingDigit: data.detail?.verifying_digit,
        dateAddedNote: data.detail?.date_added_note,
        hourAddedNote: data.detail?.hour_added_note,
        cadusKey: data.detail?.cadus_key,
        subJudice: parseDjangoSubJudice(data.detail?.sub_judice),
      },
    };
    return protests;
  } else {
    return undefined;
  }
}

function parseProtests(data?: Protests) {
  if (data) {
    const protests = {
      initialDate: data.initialDate,
      finalDate: data.finalDate,
      totalAmount: data.totalAmount,
      value: data.value,
      cityOfOrigin: data.cityOfOrigin,
      detail: {
        dateAnnotacion: data.detail?.dateAnnotacion,
        notaryNumber: data.detail?.notaryNumber,
        codeOfNature: data.detail?.codeOfNature,
        noteValue: data.detail?.noteValue,
        squareCode: data.detail?.squareCode,
        federativeUnit: data.detail?.federativeUnit,
        localityOfRegistry: data.detail?.localityOfRegistry,
        subJudiceType: data.detail?.subJudiceType,
        receivingDate: data.detail?.receivingDate,
        branchNumber: data.detail?.receivingDate,
        verifyingDigit: data.detail?.verifyingDigit,
        dateAddedNote: data.detail?.dateAddedNote,
        hourAddedNote: data.detail?.hourAddedNote,
        cadusKey: data.detail?.cadusKey,
        subJudice: parseSubJudice(data.detail?.subJudice),
      },
    };
    return protests;
  } else {
    return undefined;
  }
}

function parseDjangoJudicialActions(data?: DjangoJudicialActions) {
  if (data) {
    const judicialActions = {
      initialDate: data.initial_date,
      finalDate: data.final_date,
      totalAmount: data.total_amount,
      value: data.value,
      cityOfOrigin: data.city_of_origin,
      natureDescription: data.nature_description,
      detail: {
        dateOfOccurrence: data.detail?.date_of_occurrence,
        civilCourt: data.detail?.civil_court,
        distributorNumber: data.detail?.distributor_number,
        natureCode: data.detail?.nature_code,
        shareValue: data.detail?.share_value,
        DDI: data.detail?.DDI,
        federationUnit: data.detail?.federation_unit,
        cityName: data.detail?.city_name,
        principal: data.detail?.principal,
        branchNumber: data.detail?.branch_number,
        verifyingDigit: data.detail?.verifying_digit,
        dateAddedNote: data.detail?.date_added_note,
        hourAddedNote: data.detail?.hour_added_note,
        cadusKey: data.detail?.cadus_key,
        subJudice: parseDjangoSubJudice(data.detail?.sub_judice),
      },
    };
    return judicialActions;
  } else {
    return undefined;
  }
}

function parseJudicialActions(data?: JudicialActions) {
  if (data) {
    const judicialActions = {
      initialDate: data.initialDate,
      finalDate: data.finalDate,
      totalAmount: data.totalAmount,
      value: data.value,
      cityOfOrigin: data.cityOfOrigin,
      natureDescription: data.natureDescription,
      detail: {
        dateOfOccurrence: data.detail?.dateOfOccurrence,
        civilCourt: data.detail?.civilCourt,
        distributorNumber: data.detail?.distributorNumber,
        natureCode: data.detail?.natureCode,
        shareValue: data.detail?.shareValue,
        DDI: data.detail?.DDI,
        federationUnit: data.detail?.federationUnit,
        cityName: data.detail?.cityName,
        principal: data.detail?.principal,
        branchNumber: data.detail?.branchNumber,
        verifyingDigit: data.detail?.verifyingDigit,
        dateAddedNote: data.detail?.dateAddedNote,
        hourAddedNote: data.detail?.hourAddedNote,
        cadusKey: data.detail?.cadusKey,
        subJudice: parseSubJudice(data.detail?.subJudice),
      },
    };
    return judicialActions;
  } else {
    return undefined;
  }
}

function parseDjangoREFIN(data?: DjangoREFIN) {
  if (data) {
    const REFIN = {
      initialDate: data.initial_date,
      finalDate: data.final_date,
      totalAmount: data.total_amount,
      value: data.value,
      latestCreditor: data.latest_creditor,
      detail: {
        dateOfOccurrence: data.detail?.date_of_occurrence,
        natureCode: data.detail?.nature_code,
        CNPJParticipant: data.detail?.CNPJ_participant,
        occurrenceValue: data.detail?.occurrence_value,
        DDI: data.detail?.DDI,
        federationUnit: data.detail?.federation_unit,
        originCompanyName: data.detail?.origin_company_name,
        cityName: data.detail?.city_name,
        principal: data.detail?.principal,
        cadusKey: data.detail?.cadus_key,
        cadusKeySeries: data.detail?.cadus_key_series,
        subJudice: parseSubJudice(data.detail?.sub_judice),
        branchNumber: data.detail?.branch_number,
        verifyingDigit: data.detail?.verifying_digit,
        dateAddedNote: data.detail?.date_added_note,
        hourAddedNote: data.detail?.hour_added_note,
        contractCode: data.detail?.contract_code,
        nature: data.detail?.nature,
      },
    };
    return REFIN;
  } else {
    return undefined;
  }
}

function parseSubJudice(data?) {
  if (typeof data === 'object') {
    const subJudice = {
      square: data.square,
      distributor: data.distributor,
      civilCourt: data.civilCourt,
      date: data.date,
      process: data.process,
      message: data.message,
    };
    return subJudice;
  } else {
    return data;
  }
}

function parseSubJudicePEFIN(data?) {
  if (typeof data === 'object') {
    const subJudice = {
      square: data.square,
      distributor: data.distributor,
      civilCourt: data.civilCourt,
      date: data.date,
      process: data.process,
      message: data.message,
      occurrenceType: data.occurrenceType,
    };
    return subJudice;
  } else {
    return data;
  }
}

function parseDjangoSubJudice(data?) {
  if (typeof data === 'object') {
    const subJudice = {
      square: data.square,
      distributor: data.distributor,
      civilCourt: data.civil_court,
      date: data.date,
      process: data.process,
      message: data.message,
    };
    return subJudice;
  } else {
    return data;
  }
}

function parseDjangoSubJudicePEFIN(data?) {
  if (typeof data === 'object') {
    const subJudice = {
      square: data.square,
      distributor: data.distributor,
      civilCourt: data.civil_court,
      date: data.date,
      process: data.process,
      message: data.message,
      occurrenceType: data.occurrence_type,
    };
    return subJudice;
  } else {
    return data;
  }
}

function parseREFIN(data?: REFIN) {
  if (data) {
    const REFIN = {
      initialDate: data.initialDate,
      finalDate: data.finalDate,
      totalAmount: data.totalAmount,
      value: data.value,
      latestCreditor: data.latestCreditor,
      detail: {
        dateOfOccurrence: data.detail?.dateOfOccurrence,
        natureCode: data.detail?.natureCode,
        CNPJParticipant: data.detail?.CNPJParticipant,
        occurrenceValue: data.detail?.occurrenceValue,
        DDI: data.detail?.DDI,
        federationUnit: data.detail?.federationUnit,
        originCompanyName: data.detail?.originCompanyName,
        cityName: data.detail?.cityName,
        principal: data.detail?.principal,
        cadusKey: data.detail?.cadusKey,
        cadusKeySeries: data.detail?.cadusKeySeries,
        subJudice: parseSubJudice(data.detail?.subJudice),
        branchNumber: data.detail?.branchNumber,
        verifyingDigit: data.detail?.verifyingDigit,
        dateAddedNote: data.detail?.dateAddedNote,
        hourAddedNote: data.detail?.hourAddedNote,
        contractCode: data.detail?.contractCode,
        nature: data.detail?.nature,
      },
    };
    return REFIN;
  } else {
    return undefined;
  }
}

function parseDjangoPEFIN(data?: DjangoPEFIN) {
  if (data) {
    const PEFIN = {
      initialDate: data.initial_date,
      finalDate: data.final_date,
      totalAmount: data.total_amount,
      latestValue: data.latest_value,
      lastBankName: data.last_bank_name,
      occurrenceType: data.occurrence_type,
      creditor: {
        lenderDocument: data.creditor?.lender_document,
        lenderName: data.creditor?.lender_name,
        occurrenceType: data.creditor?.occurrence_type,
      },
      detail: {
        dateOfOccurrence: data.detail?.date_of_occurrence,
        natureCode: data.detail?.nature_code,
        occurrenceValue: data.detail?.occurrence_value,
        DDI: data.detail?.DDI,
        principal: data.detail?.principal,
        contractCode: data.detail?.contract_code,
        subJudice: parseDjangoSubJudicePEFIN(data.detail?.sub_judice),
        cadusKeySeries: data.detail?.cadus_key_series,
        cadusKey: data.detail?.cadus_key,
        occurrenceType: data.detail?.occurrence_type,
        branchName: data.detail?.branch_name,
        verifyingDigit: data.detail?.verifying_digit,
        dateAddedNote: data.detail?.date_added_note,
        hourAddedNote: data.detail?.hour_added_note,
        modality: data.detail?.modality,
      },
    };
    return PEFIN;
  } else {
    return undefined;
  }
}

function parsePEFIN(data?: PEFIN) {
  if (data) {
    const PEFIN = {
      initialDate: data.initialDate,
      finalDate: data.finalDate,
      totalAmount: data.totalAmount,
      latestValue: data.latestValue,
      lastBankName: data.lastBankName,
      occurrenceType: data.occurrenceType,
      creditor: {
        lenderDocument: data.creditor?.lenderDocument,
        lenderName: data.creditor?.lenderName,
        occurrenceType: data.creditor?.occurrenceType,
      },
      detail: {
        dateOfOccurrence: data.detail?.dateOfOccurrence,
        natureCode: data.detail?.natureCode,
        occurrenceValue: data.detail?.occurrenceValue,
        DDI: data.detail?.DDI,
        principal: data.detail?.principal,
        contractCode: data.detail?.contractCode,
        subJudice: parseSubJudicePEFIN(data.detail?.subJudice),
        cadusKeySeries: data.detail?.cadusKeySeries,
        cadusKey: data.detail?.cadusKey,
        occurrenceType: data.detail?.occurrenceType,
        branchName: data.detail?.branchName,
        verifyingDigit: data.detail?.verifyingDigit,
        dateAddedNote: data.detail?.dateAddedNote,
        hourAddedNote: data.detail?.hourAddedNote,
        modality: data.detail?.modality,
      },
    };
    return PEFIN;
  } else {
    return undefined;
  }
}

function parseDjangoScoring(data?: DjangoScoring) {
  if (data) {
    const scoring = {
      scoreCode: data.score_code,
      punctuation: data.punctuation,
      message: data.message,
      percent: data.percent,
    };
    return scoring;
  } else {
    return undefined;
  }
}

function parseScoring(data?: Scoring) {
  if (data) {
    const scoring = {
      scoreCode: data.scoreCode,
      punctuation: data.punctuation,
      message: data.message,
      percent: data.percent,
    };
    return scoring;
  } else {
    return undefined;
  }
}

export function parseDjangoDetailedConcentre(data: DjangoDetailedConcentre) {
  if (data) {
    const concentre = {
      totalAmount: data.total_amount,
      totalValue: data.total_value,
    };
    return concentre;
  } else {
    return undefined;
  }
}

export function parseDetailedConcentre(data: DetailedConcentre) {
  if (data) {
    const concentre = {
      totalAmount: data.totalAmount,
      totalValue: data.totalValue,
    };
    return concentre;
  } else {
    return undefined;
  }
}
